import React from 'react'
import { ICustomerPhone } from '../../../Interfaces/Customer/ICustomerPhone';
import { Grid, FormControlLabel, Switch, TextField, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { phoneNumberTypes } from '../../../utils/constants';
import { PhoneInput } from '@amsanalytics/react-shared-library';

interface ICustomerPhoneProps {
  phone?: ICustomerPhone;
  onUpdatePhone(phone: ICustomerPhone): void;
  disabled?: boolean;
}

const PhoneNumberCard: React.FC<ICustomerPhoneProps> = (props) => {
  // const { phone } = props;

  const handleUpdate = <T extends {} | null>(value: T, fieldName: string): void => {
    if (props.phone) {
      // Make a copy of value we are updating.
      const phone: ICustomerPhone = {
        ...props.phone
      };
      // Update property with new value.
      phone[fieldName] = value;
      props.onUpdatePhone(phone);
    }
  }

  return (
    <>
      {props.phone ?
        (
          <Grid style={{ margin: 5 }} container spacing={2}>
            <Grid item xs={6} sm={3}>
              <PhoneInput 
                style={{background: 'white', width: '100%', border: 'none'}}
                value={props.phone.phoneNumber || ''}
                onChangeValue={(val) =>
                  handleUpdate<string>(val, "phoneNumber")
                }
                label="Phone Number"
                disabled={props.disabled}
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <Select
                name="phoneType"
                disabled={props.disabled}
                label='Type'
                labelId='phone-type-label'
                variant='standard'
                value={props.phone.type || ''}
                style={{height: '100%'}}
                onChange={(e) => handleUpdate<string>(e.target.value as string, 'type')}
              >
                <MenuItem aria-label='none' value=''>
                  <em>None</em>
                </MenuItem>
                {phoneNumberTypes.map((type: string, key: number) => {
                  return (
                    <MenuItem value={type} key={key} disabled={props.disabled}>
                      {type}
                    </MenuItem>
                  );
                })}
              </Select>
            </Grid>
            <Grid item xs={6} sm={6}>
              <TextField value={props.phone.phoneBilledTo || ''}
                onChange={(e) => {
                  handleUpdate<string>(e.target.value, "phoneBilledTo")
                }}
                label="Phone Billed To"
                disabled={props.disabled}
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <FormControlLabel disabled={props.disabled} control={<Switch checked={props.phone.doNotCall || false} onChange={(event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => handleUpdate<boolean>(checked, "doNotCall")} />} label="Do not call" />
            </Grid>
            <Grid item xs={6} sm={3}>
              <FormControlLabel disabled={props.disabled} control={<Switch checked={props.phone.doNotText || false} onChange={(event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => handleUpdate<boolean>(checked, "doNotText")} />} label="Do not text" />
            </Grid>
            <Grid item xs={6} sm={2}>
              <FormControlLabel disabled={props.disabled} control={<Switch checked={props.phone.isPreferred || false} onChange={(event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => handleUpdate<boolean>(checked, "isPreferred")} />} label="Preferred" />
            </Grid>
          </Grid>
        )
        : null}
    </>)
}

export default PhoneNumberCard;
